// extracted by mini-css-extract-plugin
export default {"buttonClose":"ModalLirn_buttonClose__GXqAA","iconCloseModal":"ModalLirn_iconCloseModal__AKPuX"};